import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import { Modal, Box, CircularProgress } from "@mui/material"
import { useApiService } from "../../hooks/Api/useApiService"
import styles from "../Modals.module.css"
import ModalCloseButton from "../ModalCloseButton"
import WisdomDrop from "../../AI/WisdomDrop"
import T from "../../hooks/Language/T"
import ReflectionModal from "../ReflectionModal/ReflectionModal"
import AccessibilityPanel from "../../AccessibilityPanel/AccessibilityPanel"

const AccessibilityModal = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false)
  const [wisdom, setWisdom] = useState(null)
  const { getData } = useApiService()
  const reflectionRef = useRef()

  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <Modal open={open} onClose={handleClose}>
      <T>
        <ModalCloseButton handleClose={handleClose} />
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "background.paper",
            borderRadius: "0.8rem",
            boxShadow: 24,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <AccessibilityPanel />
        </Box>
      </T>
    </Modal>
  )
})

export default AccessibilityModal
